import { type CareSearchInitial } from '@/cam-admin/care-search/CareSearch';
import { type Scene } from '@/designs-dev/scenes';

// Initial state for the descoping prototype. Only the care search tab varies so
// far, so this is a thin pass-through to it.
export type DescopingInitial = {
  careSearch?: CareSearchInitial;
};

// The states the descoped CAM can be in, for the stage's state select.
export const descopingScenes: Scene<DescopingInitial>[] = [
  {
    id: 'default',
    label: 'Descoped CAM',
    kind: 'happy',
    repro: 'Your caseloads, all care circles, and a circle’s control panel',
    initial: {},
  },
  {
    id: 'secured-elsewhere',
    label: 'Care secured elsewhere',
    kind: 'edge',
    repro:
      'Sophie declared it on the member side. Open Margarette’s circle → Care search, and see it in the activity log and the bell',
    initial: { careSearch: { scenario: 'securedElsewhere' } },
  },
];
